import React from "reactn";

import "../scss/text.scss";
import "../scss/button.scss";

const Button = props => <button {...props}>{props.children}</button>;

export default Button;